// Class for managing the autodesk viewer instance for BIMSearch
// Connects to the BIMSearch engine and make any changes in Autodesk viewer in the BIMSearch applicaion

import {
    logError,
} from "./IAmecLog";

// .viewer - autodek viewer
export class BimsearchViewer {
    // public:
    constructor(itemStruct, divElement, bimSearch, returnMehod, modelVersion) {
        this.version = modelVersion;
        this.bimSearch = bimSearch;
        this.returnMehod = returnMehod;
        //this.doubleClickReturnMethod = doubleClickReturnMethod;
        this.onSelectionChangeCallback = null;
        this.modelName = "";
        this.viewer = null;
        this.urn = itemStruct.idToOpen;
        this.divElement = divElement;
        this.ErrorColor = new window.THREE.Vector4(1, 0, 0, 1);

        this.url = itemStruct.id;

        
        var options = {
            env: "AutodeskProduction",
            getAccessToken: this.getForgeToken,
            api:
                "derivativeV2" +
                (atob(this.urn.replace("_", "/")).indexOf("emea") > -1 ? "_EU" : ""), // handle BIM 360 US and EU regions
        };
        bimSearchViewerInstance = this;
        window.Autodesk.Viewing.Initializer(options, () => {
            bimSearchViewerInstance.intialize();
        });
    }

    intialize() {
        this.viewer = new window.Autodesk.Viewing.GuiViewer3D(this.divElement, {
            extensions: [
                "ToolbarExtension",
                "Autodesk.DocumentBrowser",
                "Autodesk.VisualClusters",
                "Autodesk.MemoryLimited",
            ],
            profileSettings: {
                settings: {
                    viewCubeCompass: true,
                    reverseMouseZoomDir: true,
                    edgeRendering: true,
                    envMapBackground: true,
                    lightPreset: "Boardwalk",
                    selectionSetPivot: true,
                },
            },
        });

        this.viewer.start();
        //this.viewer.addEventListener(
        //    window.Autodesk.Viewing.EXTENSION_LOADED_EVENT, () => { bimSearchViewerInstance.removeButtons(); });

        this.viewer.setSelectionColor(
            new window.THREE.Color(0xfa8700),
            window.Autodesk.Viewing.SelectionType.MIXED
        ); // red color
        var documentId = "urn:" + this.urn;
        this.viewer.addEventListener(
            window.Autodesk.Viewing.OBJECT_TREE_CREATED_EVENT,
            () => {
                bimSearchViewerInstance.modelLoaded();
            }
        );
        this.viewer.addEventListener(
            window.Autodesk.Viewing.EXTENSION_UNLOADED_EVENT,
            (id) => {
                bimSearchViewerInstance.closeVisualClusters(id);
            }
        );
        this.viewer.addEventListener(
            window.Autodesk.Viewing.SELECTION_CHANGED_EVENT,
            (selection) => {
                bimSearchViewerInstance.handleSelectionChange(selection);
            }
        );
        
        window.Autodesk.Viewing.Document.load(
            documentId,
            (doc) => {
                bimSearchViewerInstance.onDocumentLoadSuccess(doc);
            },
            (errorCode) => {
                bimSearchViewerInstance.onDocumentLoadFailure(errorCode);
            }
        );
    }

    async markModel(elements, badElements) {
        this.isolateElements(elements);
        this.viewer.clearThemingColors();
        badElements.forEach(element => {
            this.viewer.setThemingColor(element, this.ErrorColor);
        });
    }

    async isolateElements(elements) {
        if (this.viewer == null) return;
        if (elements == null) elements = [];
        this.viewer.clearSelection();
        this.viewer.isolate(elements);
        this.viewer.fitToView(elements);
    }

    async selectElements(elements) {
        if (this.viewer == null) return;
        if (elements == null) elements = [];
        this.viewer.isolate(elements);
        this.viewer.fitToView(elements);
        this.viewer.select(elements);
    }



    // private:
    
    onDocumentLoadSuccess(doc) {
        // if a viewableId was specified, load that view, otherwise the default view
        var viewables = doc.getRoot().getDefaultGeometry();

        // Try to find first 3d view and set it as active
        var viewItems = doc.getRoot().search({ role: "3d", type: "geometry" });
        if (viewItems.length > 0) {
            var firstViewItem = viewItems[0];
            if (
                firstViewItem.data !== undefined &&
                firstViewItem.data.guid !== undefined
            ) {
                viewables = doc.getRoot().findByGuid(firstViewItem.data.guid);
            }
        }

        this.viewer.loadDocumentNode(doc, viewables).then((i) => {
            // any additional action here?
        });
    }

    onDocumentLoadFailure(viewerErrorCode) {
        logError(
            "FrontEnd.utils.builder.BimsearchViewer.onDocumentLoadFailure",
            viewerErrorCode.toString()
        );
    }

    removeButtons() {
        if (this.viewer.toolbar == null) return;

        var navToolsConrol = this.viewer.toolbar.getControl("navTools");
        if (navToolsConrol)
            while (navToolsConrol._controls.length > 0)
                navToolsConrol.removeControl(navToolsConrol._controls[0]._id);

        var modelToolsControl = this.viewer.toolbar.getControl("modelTools");

        if (modelToolsControl) {
            modelToolsControl.removeControl("toolbar-explodeTool");
            modelToolsControl.removeControl("toolbar-sectionTool");
        }

        var settingsToolsConrol = this.viewer.toolbar.getControl("settingsTools");
        if (settingsToolsConrol)
            settingsToolsConrol.removeControl("toolbar-modelStructureTool");
    }

    // method to get credentials token
    getForgeToken(callback) {
        fetch("/api/forge/oauth/token").then((res) => {
            res.json().then((data) => {
                callback(data.access_token, data.expires_in);
            });
        });
    }

    closeVisualClusters(id) {
        if (this.viewer.loadedExtensions["Autodesk.VisualClusters"] === undefined) {
            return;
        }
        if (
            this.viewer.loadedExtensions["Autodesk.VisualClusters"].clusterButton
                ._state == 0
        )
            this.viewer.loadedExtensions[
                "Autodesk.VisualClusters"
            ].clusterButton.onClick();
    }

    async modelLoaded() {
        this.viewer.getObjectTree((tree) => {
            bimSearchViewerInstance.treeLoaded(tree);
        });
    }

    async treeLoaded(tree) {
        //set subtitile by model name and loaded version
        this.modelName = this.viewer.model
            .getData()
            .loadOptions.bubbleNode.getRootNode()
            .children[0].name();
        var modelHeader = this.modelName;
        if (this.version != null)
            modelHeader += " (" + this.version.split(":")[0] + ")";

        var res = await this.bimSearch.loadModel(this.viewer, tree, this.modelName);

        //Change Measure units
        if (
            this.viewer.loadedExtensions["Autodesk.Measure"] != null &&
            this.viewer.loadedExtensions["Autodesk.Measure"].sharedMeasureConfig !=
            null
        )
            this.viewer.loadedExtensions[
                "Autodesk.Measure"
            ].sharedMeasureConfig.units = "cm";

        this.returnMehod(modelHeader);
    }

    getFullSelectionData() {
        return this.bimSearch.getDataByCategory(this.viewer.getSelection());
    }

    async handleSelectionChange(selection) {
        if (this.onSelectionChangeCallback != null) {
            if (selection == null || selection.dbIdArray == null)
                selection.dbIdArray = [];
            var res = this.bimSearch.getCounterData(selection.dbIdArray);
            this.onSelectionChangeCallback(res);
        }
    }
}

var bimSearchViewerInstance;

const categoryPre = "Revit ";
const typeParameter = "Type Name";



